import GlobalCTA from "../components/GlobalCTA";
import TestimonialsHero from "./TestimonialsHero";
import TestimonialsList from "./TestimonialsList";

export default function ClientTestimonials() {
  return (
    <>
      <TestimonialsHero />
      <TestimonialsList />
      <GlobalCTA
        title="Ready to Work with"
        highlight="Oglitz?"
        subtitle="Join startups and enterprises worldwide who trust us to build secure, scalable digital products."
      />
    </>
  );
}
